// extracted by mini-css-extract-plugin
export default {"component_homepage_benefits":"homepage-benefits_component_homepage_benefits__Toq1v"};